var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoNavigationHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.467 0a9.935 9.935 0 1 0 0 19.87 9.935 9.935 0 0 0 0-19.87m.207 4.14a1.242 1.242 0 1 1 0 2.483 1.242 1.242 0 0 1 0-2.483m1.862 11.177H9.225a.828.828 0 1 1 0-1.656h.62a.207.207 0 0 0 .208-.207V9.728a.207.207 0 0 0-.207-.207h-.621a.828.828 0 1 1 0-1.656h.828a1.656 1.656 0 0 1 1.656 1.656v3.933a.207.207 0 0 0 .207.207h.62a.828.828 0 1 1 0 1.656",
  className: "ico-navigation-help_svg__fill"
})));
export { SvgIcoNavigationHelp as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-navigation-help.e9e801f7.svg";